import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import Text from "../Text/Text";
import Dropdown from "../Dropdown/Dropdown";
import Button from "../Button/Button";
import LanguageIcon from "../Svg/Icons/Language";
import MenuButton from "./MenuButton";
import { useMatchBreakpoints } from "../../hooks";
var MoblieButton = styled(Button).withConfig({
    componentId: "sc-a5923604-0"
})(_templateObject(), function(param) {
    var isMobile = param.isMobile;
    return isMobile && "padding-left: 0;";
});
var LangSelector = function(param) {
    var currentLang = param.currentLang, langs = param.langs, color = param.color, setLang = param.setLang, _dropdownPosition = param.dropdownPosition, dropdownPosition = _dropdownPosition === void 0 ? "bottom" : _dropdownPosition, _buttonScale = param.buttonScale, buttonScale = _buttonScale === void 0 ? "md" : _buttonScale, _hideLanguage = param.hideLanguage, hideLanguage = _hideLanguage === void 0 ? false : _hideLanguage;
    var isMobile = useMatchBreakpoints().isMobile;
    return /*#__PURE__*/ _jsx(Dropdown, {
        position: dropdownPosition,
        target: /*#__PURE__*/ _jsx(MoblieButton, {
            isMobile: isMobile,
            scale: buttonScale,
            variant: "text",
            startIcon: /*#__PURE__*/ _jsx(LanguageIcon, {
                color: color,
                width: "20px"
            }),
            children: !hideLanguage && /*#__PURE__*/ _jsx(Text, {
                color: color,
                children: currentLang === null || currentLang === void 0 ? void 0 : currentLang.toUpperCase()
            })
        }),
        children: langs.map(function(lang) {
            return /*#__PURE__*/ _jsx(MenuButton, {
                fullWidth: true,
                onClick: function() {
                    return setLang(lang);
                },
                // Safari fix
                style: {
                    minHeight: "32px",
                    height: "auto"
                },
                children: lang.language
            }, lang.locale);
        })
    });
};
export default /*#__PURE__*/ React.memo(LangSelector, function(prevProps, nextProps) {
    return prevProps.currentLang === nextProps.currentLang && prevProps.dropdownPosition === nextProps.dropdownPosition;
});
